import { createActions } from 'utils/actions';

/**
 * Redux actions to store the MFA session, i.e. the short lived `mfa_token` and
 * the MFA details returned by the authenticate API.
 *
 * @type {Object}
 */
export const setMFASession = createActions('mfa', 'SET_MFA_SESSION');

/**
 * Redux actions to clear the MFA session.
 *
 * @type {Object}
 */
export const clearMFASession = createActions('mfa', 'CLEAR_MFA_SESSION');

/**
 * Redux actions to clear the error of the last verification attempt, the MFA
 * session itself, i.e. the `mfaToken` and the attempts left, is kept.
 *
 * @type {Object}
 */
export const clearMFAError = createActions('mfa', 'CLEAR_MFA_ERROR');

/**
 * Redux actions to clear the error of the last enrollment attempt.
 *
 * @type {Object}
 */
export const clearMFAEnrollmentError = createActions('mfa', 'CLEAR_MFA_ENROLLMENT_ERROR');

/**
 * Redux actions for the MFA enrollment flow, i.e. registering the method the
 * user picked on the setup screen.
 *
 * @type {Object}
 */
export const registerMFAMethod = createActions('mfa', 'REGISTER_MFA_METHOD');

/**
 * Redux actions for the MFA code verification flow.
 *
 * @type {Object}
 */
export const verifyMFACode = createActions('mfa', 'VERIFY_MFA_CODE');

/**
 * Redux actions to leave the enrollment success screen, i.e. complete the sign
 * in the enrollment was started from.
 *
 * @type {Object}
 */
export const completeMFAEnrollment = createActions('mfa', 'COMPLETE_MFA_ENROLLMENT');
